import 'twin.macro';
import React from 'react';
import Popover from 'components/Popover';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { CahierJournalView } from 'containers/CahierJournal/types';
import { Body } from './Body';

interface Props {
  workingDays: number[];
  view: CahierJournalView;
  date: Date;
}

export function CalendarPopover(props: Props) {
  return (
    <Popover portal>
      <Popover.Button icon={CalendarDaysIcon} aria-label="Aller à la date" />
      <Popover.Panel size="auto">
        <Body {...props} />
      </Popover.Panel>
    </Popover>
  );
}
